import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { handleErrors } from '../../actions/ErrorActions';
import { getEntitiesList } from '../../api/entities-list';
import EditorDashboard from '../../components/EditorDashboard';
import { RECENT_ENTITIES_QUANTITY } from '../../constants/EntityDesignerConstants';
import { STANDALONE_DASHBOARD_TYPES } from '../../constants/StandaloneLayoutConstants';
import { ENTITIES_LIST, ENTITY_EDITOR } from '../../constants/Urls';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { importEntity as importEntityAction } from '../../entity-designer/actions/entity-designer.actions';
import { modifyEntities } from '../../utils/entitiesListUtils';
import NavigateLinkCell from '../FindPage/NavigateLinkCell';

const EntitiesListPage = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const translateString = useTranslation();
  const title = translateString('Entities');
  const [isLoading, setIsLoading] = useState(false);
  const [items, setItems] = useState([]);

  useEffect(() => {
    document.title = 'Entity Designer';

    const loadEntities = async () => {
      setIsLoading(true);
      const response = await getEntitiesList();
      if (!response.hasError) {
        const { entities } = response;
        setItems(modifyEntities(entities));
      } else {
        dispatch(handleErrors(response.errors));
      }
      setIsLoading(false);
    };

    loadEntities();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const navigateToItemEditor = useCallback(
    ({ id }) => {
      history.push({
        pathname: ENTITY_EDITOR,
        search: `?itmId=${id}&standaloneLayout=true`,
      });
    },
    [history]
  );

  const redirectToEntityDesigner = () => {
    history.push({
      pathname: ENTITY_EDITOR,
      search: '?import=true&standaloneLayout=true',
    });
  };

  const importEntity = useCallback(async (file) => {
    await dispatch(importEntityAction({ file, redirectToEntityDesigner }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <EditorDashboard
      dashboardTitle={title}
      dashboardLink={ENTITIES_LIST}
      itemName="Entities"
      navigateToItemEditor={navigateToItemEditor}
      itemQuantity={RECENT_ENTITIES_QUANTITY}
      customCell={NavigateLinkCell.forUrl(ENTITY_EDITOR)}
      isLoading={isLoading}
      items={items}
      itemTitle={translateString('Recent Entities')}
      entityName="EntityDefinition"
      initialSearchName="All Entities"
      dashboardType={STANDALONE_DASHBOARD_TYPES.ENTITIES}
      importFile={importEntity}
    />
  );
};

export default EntitiesListPage;
